import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import { UserContext, BaseComponent, Anomalia, GlobalFilter, AnomalieResponse } from '../core/core.component';
import { AppConstants } from '../core/app.constants';
import { MessageProvider } from '../service/message.service';
import { AnomalieService} from '../service/anomalie.service';
import { PresenzeService} from '../service/presenze.service';
import { GlobalFilterService} from '../service/global-filter.service';
import { SelectItem } from 'primeng/primeng';
import { UserService } from 'app/service/user.service';

@Component({
  selector: 'app-user-anomalies',
  templateUrl: './user-anomalies.component.html',
  styleUrls: ['./user-anomalies.component.css']
})
export class UserAnomaliesComponent extends BaseComponent implements OnInit 
{
    public static LIVELLO_ANOMALIE_LOCALSTORE_KEY = 'livello-anomalie-key';

    userContext: UserContext;
    isUserAdmin: boolean = false;
    @Input() isFullSize: boolean = false;
    completed:  boolean = true;
    anomalies: Anomalia[] = [];
    users: SelectItem[] = [];
    userSelected: number = -1;
    sortField: string = "";
    sortAsc: boolean = false;
    anomalyLevels: SelectItem[] = [];
    selectedLevel: number = null;

    @Output() fullSize = new EventEmitter<boolean>();
    @Output() anomaliesCounter = new EventEmitter<number>();
    
    constructor(protected authAccess: AuthAccessProvider, 
            protected router: Router,
            protected messageProvider: MessageProvider,
            private anomalieService: AnomalieService,
            private globalFilter: GlobalFilterService,
            private presenzeService: PresenzeService,
            private userService: UserService,
            private datePipe: DatePipe) {
        super(authAccess, router, messageProvider);
    }

  ngOnInit() {
      this.userContext = this.authAccess.getUserContext();
      if (this.userContext == null) {    
          this.authAccess.invalidate();
      } else {
        const livelloLocalStore = localStorage.getItem(UserAnomaliesComponent.LIVELLO_ANOMALIE_LOCALSTORE_KEY);
        if (livelloLocalStore && !isNaN(Number(livelloLocalStore))) {
            this.selectedLevel = Number(livelloLocalStore);
        }
        this.anomalieService.getAnomalyLevels(this.userContext.srmToken).subscribe(
            result => {
                this.anomalyLevels = [];
                if (result) {
                    result.levels.forEach(level => {
                        this.anomalyLevels.push({label: "Priorità " + level, value: level});
                    });
                    if (!this.selectedLevel) {
                        this.selectedLevel = result.levels[result.levels.length - 1];
                    }
                }
                this.load();
            },
            error => {
                this.handleError(error);
            }  
        );

        this.userService.isUserAdmin(this.userContext.srmToken).subscribe(
            result => {
                this.isUserAdmin = result.message == "true";
            },
            error => {
                this.handleError(error);
            }
        );
      }
  }
  
  load() {
      this.completed = false;
      this.anomalies = [];
      this.userSelected = -1;
      this.users = [];
      this.messageProvider.clearAll();
      
      let currentResp: AnomalieResponse;
      this.anomalieService.getAnomalieForAllUser(this.userContext.srmToken).subscribe(
           result => {
               currentResp = result;
               this.anomalies = currentResp.userAnomalies;
               this.users.push({label: "Tutti", value: -1});
               this.userSelected = -1;
               let distinctUserID: number[] = [];
               for(let i = 0; i < this.anomalies.length; ++i) {
                   let anom =  this.anomalies[i];
                   if(!distinctUserID.includes(anom.userId)) {
                       this.users.push({label: anom.fullname, value: anom.userId});
                       distinctUserID.push(anom.userId);
                   }
               }
               this.anomaliesCounter.emit(this.anomalies.length);
               var sortBy = this.sortField == "" ? "priority" : this.sortField;
               this.sortField = ""; // altrimenti sul refresh mi inverte l'ordinamento
               this.sort(sortBy);
               this.completed = true;
           },   
           error => {
               this.completed = true;
               this.handleError(error);
           }   
      );
  }
  
  sort(field: string) { 
      if (field == this.sortField) {
          this.anomalies =  this.anomalies.reverse();
          this.sortAsc = !this.sortAsc;
      } else {
          this.sortField = field;
          this.sortAsc = true;
          this.anomalies = this.anomalies.sort((a1, a2) =>
              {
                  let d1 = this.datePipe.transform(a1.date, "yyyyMMdd");
                  let d2 = this.datePipe.transform(a2.date, "yyyyMMdd");
                  
                  if(this.sortField == "priority") {
                      if(a1.priority == a2.priority) {
                          if(a1.anomaly == a2.anomaly) {
                            if(a1.fullname == a2.fullname) {
                                return d1 > d2 ? -1 : 1;
                            }
                            return a1.fullname > a2.fullname? 1 : -1;
                          }
                          return a1.anomaly > a2.anomaly ? 1 : -1;
                      }
                      return a1.priority < a2.priority ? -1 : 1;
                  } else if(this.sortField == "anomaly") {
                    if(a1.anomaly == a2.anomaly) {
                        if(a1.fullname == a2.fullname) {
                            return d1 > d2 ? -1 : 1;
                        }
                        return a1.fullname > a2.fullname? 1 : -1;
                     }
                    return a1.anomaly > a2.anomaly ? 1 : -1;
                  } else if(this.sortField == "date") {
                      if(d1 == d2) {
                         return a1.fullname > a2.fullname ? 1 : -1; 
                      }   
                      return d1 > d2 ? -1 : 1;
                  } else if(this.sortField == "user") {
                      if(a1.fullname == a2.fullname) {
                          return d1 > d2 ? -1 : 1;
                      }
                      return a1.fullname > a2.fullname? 1 : -1;
                  } else if(this.sortField == "type") {
                      if(a1.blocking == a2.blocking) {
                            return d1 > d2 ? -1 : 1; 
                      }
                      return a1.blocking == true? 1 : -1;
                  }
                  return 0;
              });
      }
  }
  
  setGlobalFilterAnomalyDate(anomalia: Anomalia) {
      let _date : Date = AppConstants.parseDate(this.datePipe.transform(anomalia.date, "dd/MM/yyyy"));
      let filter: GlobalFilter = new GlobalFilter();
      filter.dateFrom = _date;
      filter.dateTo = filter.dateFrom;
      let user: SelectItem[] = [];
      user.push({label: anomalia.fullname, value: anomalia.userId});
      filter.users = user;
      this.globalFilter.setGlobalFilter(filter);
      this.presenzeService.openPresenceSection();
  }
  
  setFullSize() {
      this.fullSize.emit(true);
      this.isFullSize = true;
  }
  resize() {
      this.fullSize.emit(false);
      this.isFullSize = false;
    }
    
    aggiornaLivello() {
        if (this.selectedLevel) {
            localStorage.setItem(UserAnomaliesComponent.LIVELLO_ANOMALIE_LOCALSTORE_KEY, this.selectedLevel+"");
        }
    }
  
}



// WEBPACK FOOTER //
// ./src/app/user-anomalies/user-anomalies.component.ts